// extracted by mini-css-extract-plugin
export default {"container":"InnerWidget__container___Ds8y3","title":"InnerWidget__title___jf5Mv"};